import { IPaymentMethod } from "@nju/data-access-portal-user";
import { Icon } from "@nju/icons";
import { BlockText, Text } from "@nju/ui";
import { formatPrice } from "@nju/utils";

interface IPaymentsProps {
  activationFee: number;
  paymentMethod?: IPaymentMethod;
  subscriptionPrice: number;
}

export function Payments({
  activationFee,
  paymentMethod,
  subscriptionPrice,
}: IPaymentsProps) {
  const isDigitalWalletOrBlik = paymentMethod?.methodType === "DIGITAL_WALLET";
  const isCreditCard = paymentMethod?.methodType === "CREDIT_CARD";
  const icon = "mr-4 w-6 h-6 from-tablet:w-7 from-tablet:h-7";

  return (
    <div className="grid gap-3">
      {paymentMethod && (
        <>
          <div className="items-center flex">
            {isDigitalWalletOrBlik && (
              <>
                <Icon className={icon} name="wallet" tone="accent" />
                <div className="flex-1">
                  <Text
                    size={{
                      "@onlyMobile": "s",
                      "@fromTablet": "m",
                    }}
                  >
                    wybrany sposób płatności
                  </Text>
                  <BlockText
                    size={{
                      "@onlyMobile": "s",
                      "@fromTablet": "l",
                    }}
                    weight="bold"
                  >
                    BLIK lub płatność online
                  </BlockText>
                </div>
              </>
            )}
            {isCreditCard && (
              <>
                <Icon className={icon} name="credit-card" tone="accent" />
                <div className="flex-1">
                  <Text
                    size={{
                      "@onlyMobile": "s",
                      "@fromTablet": "m",
                    }}
                  >
                    wybrany sposób płatności
                  </Text>
                  <BlockText
                    size={{
                      "@onlyMobile": "s",
                      "@fromTablet": "l",
                    }}
                    weight="bold"
                  >
                    karta płatnicza **** **** ****{" "}
                    {paymentMethod?.details.maskedCardNumber}
                  </BlockText>
                </div>
              </>
            )}
          </div>
        </>
      )}
      <div className="flex items-center">
        <Icon className={icon} name="wallet" tone="accent" />
        <div className="flex-1">
          <Text
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            jednorazowa opłata aktywacyjna
          </Text>
          <BlockText
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "l",
            }}
            testId="mobile-monthly-fee"
            weight="bold"
          >
            {`${formatPrice(activationFee ?? 0)} zł`}
          </BlockText>
        </div>
      </div>
      <div className="flex items-center">
        <Icon className={icon} name="wallet" tone="accent" />
        <div className="flex-1">
          <Text
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            opłata miesięczna
          </Text>
          <BlockText
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "l",
            }}
            testId="mobile-monthly-fee"
            weight="bold"
          >
            {`${formatPrice(subscriptionPrice)} zł`}
          </BlockText>
        </div>
      </div>
    </div>
  );
}
